import { DangerousHtmlContent, Notification, variants } from '@eti/components';
import { useProperty, useTranslation } from '@eti/providers';
import { getPriceNotificationContent } from '../../../../utils/notification';
import type { TripChange } from '../../models';

interface PriceChangeNotificationProps {
  tripChange: TripChange;
}

const PriceChangeNotification = ({ tripChange }: PriceChangeNotificationProps) => {
  const { p } = useProperty();
  const { t } = useTranslation();

  const willShowPriceChangeSummaryInPaymentDialog = p('Payment.PriceChangeDialogSummary.Enabled');

  return !willShowPriceChangeSummaryInPaymentDialog && tripChange.price ? (
    <Notification
      dataTestId="paymentPage-priceChangeNotification-TripNotification"
      variant={variants.INFORMATION}
    >
      <DangerousHtmlContent
        content={getPriceNotificationContent({
          tripChange,
          higherText: t('Notification.PriceIncrease.Message'),
        })}
      />
    </Notification>
  ) : null;
};

export default PriceChangeNotification;
